import { Button, Heading } from '@tq/ui-components';
import { useMapPolygon } from 'api';
import { useTranslation } from 'react-i18next';
import { FaDownload } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { MapGeoJson } from '../MapWithPolygon';

export const ExportOptions: React.FC<{
  applicationReference: string | undefined;
}> = ({ applicationReference }) => {
  const { t } = useTranslation('case_details_map');
  const { id } = useParams();
  const { data: polygonData } = useMapPolygon(+(id ?? 0));

  const downloadGeoJSON = (filename: string, json: MapGeoJson) => {
    const url = window.URL.createObjectURL(
      new Blob([JSON.stringify(json)], {
        type: 'text/json;charset=utf-8',
      })
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${filename.replaceAll('/', '_')}.json`);
    link.click();
  };

  const handleDownloadSpatialClick = () => {
    if (polygonData?.geoJson) {
      downloadGeoJSON(applicationReference || 'geoJSON', polygonData.geoJson);
    }
  };

  return (
    <>
      <Heading size='md' mb={4}>
        {t('export_red_line_boundary', 'Export red line boundary')}
      </Heading>
      <Button
        mb={4}
        height={8}
        pl={3}
        justifyContent='flex-start'
        variant='secondary'
        rightIcon={<FaDownload />}
        onClick={handleDownloadSpatialClick}
      >
        {t('spatial_file_download', 'Spatial file download')}
      </Button>
    </>
  );
};
